var _ellipse, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChaserPin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 58,
    viewBox: "0 0 48 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.0001,
    cy: 55.5,
    rx: 9,
    ry: 2.5,
    fill: "#6F758F"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.958 42.8111C39.7933 42.1097 40.58 41.3507 41.3123 40.5403L41.4985 40.3607C41.5452 40.3156 41.5808 40.2641 41.6059 40.2093C45.274 35.9952 47.5001 30.4542 47.5001 24.3869C47.5001 11.2024 36.9866 0.5 24.0001 0.5C11.0136 0.5 0.500122 11.2024 0.500122 24.3869C0.500122 30.4545 2.72645 35.9957 6.39491 40.2098C6.41993 40.2645 6.4554 40.3157 6.50195 40.3606L6.68597 40.5381C7.41948 41.3501 8.20761 42.1104 9.04447 42.813L22.6782 55.9634C23.4199 56.6788 24.5806 56.6789 25.3223 55.9635L38.958 42.8111Z",
    fill: "#6F758F",
    stroke: "#192337"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChaserPin);
export default __webpack_public_path__ + "static/media/chaser-pin.540713a3.svg";
export { ForwardRef as ReactComponent };